import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { throwError } from 'rxjs';
import { GlobalService } from '../services/global.service';
import { Router } from '@angular/router';
import { MessageHandler } from 'src/app/shared/handlers/message-handler';
import { MatDialog } from '@angular/material/dialog';
import { UnauthorizedDialogComponent } from '../components/unauthorized-dialog/unauthorized-dialog.component';
import { AlertHandler } from './alert-handler';

@Injectable()
export class InterceptorHandler implements HttpInterceptor {
  constructor(private globalService: GlobalService, private router: Router, public dialog: MatDialog) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.globalService.token;
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `${token}`,
          // 'Content-Type': 'application/json',
        },
      });
    }

    // To handle FormData
    if (request.body && request.body.isFormData) {
      delete request.body.isFormData;

      const formData = new FormData();
      for (let i in request.body) {
        formData.append(i, request.body[i]);
      }
      request = request.clone({ body: formData });
    } else {
      if (!request.headers.has('Content-Type') && !(request.body instanceof FormData)) {
        request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
      }
    }

    //------------------------------------

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        console.log(err);
        let errMessage = MessageHandler.INTERNAL_ERROR;
        if (err.status === 401 && this.globalService.expiredCounter === 0) {
          this.globalService.expiredCounter = this.globalService.expiredCounter + 1;

          errMessage = err.error.message + ' :Please Login Again';

          const dialogRef = this.dialog.open(UnauthorizedDialogComponent, {
            width: '40vw',
            maxWidth: '400px',
            height: '200px',
            disableClose: true,
            position: { top: '5%' },
            data: { errMessage },
          });
          dialogRef.afterClosed().subscribe((res) => {
            if (res === true) {
              this.globalService.deleteUserSession();
              this.router.navigate(['auth/login']);
            }
          });
        }
        if (err.status === 403) {
          errMessage = err?.error.message;
        }
        if (err.status != 401 && err.status != 404) {
          // alert(errMessage);
          AlertHandler.ErrorAlert(errMessage);
        }
        return throwError(() => err);
      })
    );
  }
}
